import React from "react";
import UserAvatar from "../atoms/UserAvatar";
import { INK, LINE } from "../../Bureau/bureauTokens";

function ConversationHeader({ otherUser }) {
  const name = otherUser ? `${otherUser.name || ""} ${otherUser.lastName || ""}`.trim() : "Collaborateur";

  return (
    <div
      className="flex items-center gap-3 px-4 py-3.5 flex-shrink-0 sticky top-0 bg-white z-10"
      style={{ borderBottom: `1px solid ${LINE}` }}
    >
      <UserAvatar name={otherUser?.name} lastName={otherUser?.lastName} picture={otherUser?.picture} size={36} />
      <div className="text-[14px] font-semibold" style={{ color: INK }}>
        {name}
      </div>
    </div>
  );
}

export default ConversationHeader;
